// extracted by mini-css-extract-plugin
module.exports = {"wide":"Anonymous_wide__3NP7t"};